/* export const KeyforgeKraken = {
  gueuleTitanesque: {
    name: "Gueule Titanesque",
    images: {
      front:
        "Fichier%201.png",
      back:
        "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN"
    }
  }
}; */

export const imagesUrlPrefix = lang =>
  `https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/keyraken/${lang}/`;

export const CardsCatalog = {
  // keyforge
  mb: {
    name: "Marée",
    images: {
      front: "keyraken_0a.png",
      back: "keyraken_0b.png"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "REVEALS"
    }
  },
  keyraken: {
    name: "keyraken",
    images: {
      front: "keyraken_1.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "VILLAINS"
    }
  },
  gueuleTitanesque: {
    name: "Gueule Titanesque",
    images: {
      front: "keyraken_46.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  primordial: {
    name: "Primordial",
    images: {
      front: "keyraken_45.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  eddyTroublion: {
    name: "Eddy Troublion",
    images: {
      front: "keyraken_43.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  courantRapide: {
    name: "Courant Rapide",
    images: {
      front: "keyraken_40.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  jetAscendant: {
    name: "Jet Ascendant",
    images: {
      front: "keyraken_39.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  revelationDuZelote: {
    name: "Revelation du Zelote",
    images: {
      front: "keyraken_37.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  mareeDeMorteEau: {
    name: "Marée de morte Eau",
    images: {
      front: "keyraken_36.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  contreVentsEtMarees: {
    name: "Contre Vents et Marées",
    images: {
      front: "keyraken_35.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  leVilainPetitCalmar: {
    name: "Le Vilain petit Calmar",
    images: {
      front: "keyraken_34.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  courseVersLaSurface: {
    name: "Course vers la surface",
    images: {
      front: "keyraken_33.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 3,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  volonteSurnaturelle: {
    name: "Volonte surnaturelle",
    images: {
      front: "keyraken_30.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 3,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  laisseDansSonSillage: {
    name: "Laisse dans son sillage",
    images: {
      front: "keyraken_27.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  dansLesAbysses: {
    name: "Dans les abysses",
    images: {
      front: "keyraken_26.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  emergence: {
    name: "Emergence",
    images: {
      front: "keyraken_25.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  conduitASaPerte: {
    name: "Conduit à sa perte",
    images: {
      front: "keyraken_23.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  toutDevorer: {
    name: "Tout dévorer",
    images: {
      front: "keyraken_22.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 3,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  defendreLeKeyraken: {
    name: "Defendre le Keyraken",
    images: {
      front: "keyraken_19.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  pilonnageEcarlate: {
    name: "Pilonnage écarlate",
    images: {
      front: "keyraken_17.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  admirerSaGrandeur: {
    name: "Admirer sa grandeur",
    images: {
      front: "keyraken_16.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  beteLegendaire: {
    name: "Bête légendaire",
    images: {
      front: "keyraken_14.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 1,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  brasTenace: {
    name: "Bras tenace",
    images: {
      front: "keyraken_13.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  brasGlissant: {
    name: "Bras glissant",
    images: {
      front: "keyraken_11.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  brasBouclier: {
    name: "Bras bouclier",
    images: {
      front: "keyraken_9.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  tentaculeFouettant: {
    name: "Tentacule fouettant",
    images: {
      front: "keyraken_7.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  tentaculeSaisissant: {
    name: "Tentacule saisissant",
    images: {
      front: "keyraken_5.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  brasEcrasant: {
    name: "Bras écrasant",
    images: {
      front: "keyraken_3.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "DECK"
    }
  },
  creatureLog: {
    name: "Créature log",
    images: {
      front: "Log.png",
      back: "keyraken_back_2.png?raw=true"
    },
    metadatas: {
      tags: ["KEYFORGE"],
      required: 2,
      targetName: "KF_KRAKEN",
      defaultBox: "VILLAINS"
    }
  },
  // ----------
  spiderMan: {
    name: "Spider-Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "SPIDER_MAN"],
      targetName: "SPIDER_MAN"
    }
  },
  blackCatFeliciaHardy: {
    name: "Black Cat: Felicia Hardy",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "SPIDER_MAN"
    }
  },
  backflip: {
    name: "Backflip",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  enhancedSpiderSense: {
    name: "Enhanced Spider-Sense",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  swingingWebKick: {
    name: "Swinging Web Kick",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "SPIDER_MAN"
    }
  },
  auntMay: {
    name: "Aunt May",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "SPIDER_MAN"
    }
  },
  spiderTracer: {
    name: "Spider-Tracer",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  webShooter: {
    name: "Web-Shooter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  webbedUp: {
    name: "Webbed Up",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  captainMarvel: {
    name: "Captain Marvel",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01010a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01010b.jpg"
    },
    metadatas: {
      tags: ["HERO", "CAPTAIN_MARVEL"],
      targetName: "CAPTAIN_MARVEL"
    }
  },
  spiderWomanJessicaDrew: {
    name: "Spider-Woman: Jessica Drew",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  crisisInterdiction: {
    name: "Crisis Interdiction",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  photonicBlast: {
    name: "Photonic Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  energyAbsorption: {
    name: "Energy Absorption",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "RESOURCE"],
      required: 2,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  alphaFlightStation: {
    name: "Alpha Flight Station",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  captainMarvel039SHelmet: {
    name: "Captain Marvel&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  cosmicFlight: {
    name: "Cosmic Flight",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  energyChannel: {
    name: "Energy Channel",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  sheHulk: {
    name: "She-Hulk",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01019a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01019b.jpg"
    },
    metadatas: {
      tags: ["HERO", "SHE_HULK"],
      targetName: "SHE_HULK"
    }
  },
  hellcatPatsyWalker: {
    name: "Hellcat: Patsy Walker",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01020.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  gammaSlam: {
    name: "Gamma Slam",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01021.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  groundStomp: {
    name: "Ground Stomp",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01022.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "SHE_HULK"
    }
  },
  legalPractice: {
    name: "Legal Practice",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01023.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "SHE_HULK"
    }
  },
  oneTwoPunch: {
    name: "One-Two Punch",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "SHE_HULK"
    }
  },
  splitPersonality: {
    name: "Split Personality",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  superhumanLawDivision: {
    name: "Superhuman Law Division",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  focusedRage: {
    name: "Focused Rage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SHE_HULK"
    }
  },
  superhumanStrength: {
    name: "Superhuman Strength",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SHE_HULK", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SHE_HULK"
    }
  },
  ironMan: {
    name: "Iron Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01029a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01029b.jpg"
    },
    metadatas: {
      tags: ["HERO", "IRON_MAN"],
      targetName: "IRON_MAN"
    }
  },
  warMachineJamesRhodes: {
    name: "War Machine: James Rhodes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04020.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  repulsorBlast: {
    name: "Repulsor Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "IRON_MAN"
    }
  },
  supersonicPunch: {
    name: "Supersonic Punch",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "IRON_MAN"
    }
  },
  pepperPotts: {
    name: "Pepper Potts",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  starkTower: {
    name: "Stark Tower",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  arcReactor: {
    name: "Arc Reactor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01035.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  markVArmor: {
    name: "Mark V Armor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01036.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  markVHelmet: {
    name: "Mark V Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01037.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  poweredGauntlets: {
    name: "Powered Gauntlets",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01038.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "IRON_MAN"
    }
  },
  rocketBoots: {
    name: "Rocket Boots",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01039.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["IRON_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "IRON_MAN"
    }
  },
  blackPanther: {
    name: "Black Panther",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01040a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01040b.jpg"
    },
    metadatas: {
      tags: ["HERO", "BLACK_PANTHER"],
      targetName: "BLACK_PANTHER"
    }
  },
  shuri: {
    name: "Shuri",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01041.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  ancestralKnowledge: {
    name: "Ancestral Knowledge",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01042.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  wakandaForever: {
    name: "Wakanda Forever!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01043d.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "BLACK_PANTHER"
    }
  },
  vibranium: {
    name: "Vibranium",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01044.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "RESOURCE"],
      required: 3,
      targetName: "BLACK_PANTHER"
    }
  },
  theGoldenCity: {
    name: "The Golden City",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01045.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  energyDaggers: {
    name: "Energy Daggers",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01046.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  pantherClaws: {
    name: "Panther Claws",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01047.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  tacticalGenius: {
    name: "Tactical Genius",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01048.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  vibraniumSuit: {
    name: "Vibranium Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01049.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_PANTHER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  hulkBruceBanner: {
    name: "Hulk: Bruce Banner",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01050.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  tigraGreerGrantNelson: {
    name: "Tigra: Greer Grant Nelson",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01051.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  chaseThemDown: {
    name: "Chase Them Down",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01052.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  relentlessAssault: {
    name: "Relentless Assault",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01053.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  uppercut: {
    name: "Uppercut",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01054.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  thePowerOfAggression: {
    name: "The Power of Aggression",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01055.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "RESOURCE"]
    }
  },
  tacTeam: {
    name: "Tac Team",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01056.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "SUPPORT"]
    }
  },
  combatTraining: {
    name: "Combat Training",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01057.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  daredevilMattMurdock: {
    name: "Daredevil: Matt Murdock",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01058.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "ALLY"]
    }
  },
  jessicaJones: {
    name: "Jessica Jones",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01059.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "ALLY"]
    }
  },
  forJustice: {
    name: "For Justice!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01060.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  greatResponsibility: {
    name: "Great Responsibility",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01061.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  thePowerOfJustice: {
    name: "The Power of Justice",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01062.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "RESOURCE"]
    }
  },
  interrogationRoom: {
    name: "Interrogation Room",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01063.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "SUPPORT"]
    }
  },
  surveillanceTeam: {
    name: "Surveillance Team",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01064.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "SUPPORT"]
    }
  },
  heroicIntuition: {
    name: "Heroic Intuition",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01065.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  hawkeye: {
    name: "Hawkeye",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "HAWKEYE"],
      targetName: "HAWKEYE"
    }
  },
  mariaHill: {
    name: "Maria Hill",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01067.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  vision: {
    name: "Vision",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01068.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  getReady: {
    name: "Get Ready",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01069.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  leadFromTheFront: {
    name: "Lead from the Front",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01070.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  makeTheCall: {
    name: "Make the Call",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01071.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  thePowerOfLeadership: {
    name: "The Power of Leadership",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01072.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "RESOURCE"]
    }
  },
  theTriskelion: {
    name: "The Triskelion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01073.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "SUPPORT"]
    }
  },
  inspired: {
    name: "Inspired",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01074.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "UPGRADE"]
    }
  },
  blackWidowNatashaRomanoff: {
    name: "Black Widow: Natasha Romanoff",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01075.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  lukeCage: {
    name: "Luke Cage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01076.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  counterPunch: {
    name: "Counter-Punch",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01077.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  getBehindMe: {
    name: "Get Behind Me!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01078.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  thePowerOfProtection: {
    name: "The Power of Protection",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01079.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "RESOURCE"]
    }
  },
  medTeam: {
    name: "Med Team",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01080.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "SUPPORT"]
    }
  },
  armoredVest: {
    name: "Armored Vest",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01081.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  indomitable: {
    name: "Indomitable",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01082.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  mockingbirdBobbiMorse: {
    name: "Mockingbird: Bobbi Morse",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  nickFury: {
    name: "Nick Fury",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01084.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  emergency: {
    name: "Emergency",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01085.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  firstAid: {
    name: "First Aid",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01086.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  haymaker: {
    name: "Haymaker",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01087.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  energy: {
    name: "Energy",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01088.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "RESOURCE"]
    }
  },
  genius: {
    name: "Genius",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01089.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "RESOURCE"]
    }
  },
  strength: {
    name: "Strength",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01090.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "RESOURCE"]
    }
  },
  avengersMansion: {
    name: "Avengers Mansion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01091.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "SUPPORT"]
    }
  },
  helicarrier: {
    name: "Helicarrier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01092.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "SUPPORT"]
    }
  },
  tenacity: {
    name: "Tenacity",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01093.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  rhinoI: {
    name: "Rhino (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01094.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  rhinoIi: {
    name: "Rhino (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01095.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  rhinoIii: {
    name: "Rhino (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01096.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  theBreakIn: {
    name: "The Break-In!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01097.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  armoredRhinoSuit: {
    name: "Armored Rhino Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01098.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  charge: {
    name: "Charge",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01099.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RHINO"
    }
  },
  enhancedIvoryHorn: {
    name: "Enhanced Ivory Horn",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01100.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  hydraMercenary: {
    name: "Hydra Mercenary",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  sandman: {
    name: "Sandman",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01102.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  shocker: {
    name: "Shocker",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01103.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  hardToKeepDown: {
    name: "Hard to Keep Down",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01104.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RHINO"
    }
  },
  QuotI039MToughQuot: {
    name: "&quot;I&#039;m Tough&quot;",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01105.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RHINO"
    }
  },
  stampede: {
    name: "Stampede",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01106.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "RHINO"
    }
  },
  breakin039AmpTakin039: {
    name: "Breakin&#039; &amp; Takin&#039;",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01107.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  crowdControl: {
    name: "Crowd Control",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01108.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RHINO"
    }
  },
  bombScare: {
    name: "Bomb Scare",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01109.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BOMB_SCARE"
    }
  },
  hydraBomber: {
    name: "Hydra Bomber",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04066.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "CROSSBONES"
    }
  },
  explosion: {
    name: "Explosion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01111.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BOMB_SCARE"
    }
  },
  falseAlarm: {
    name: "False Alarm",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01112.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "BOMB_SCARE"
    }
  },
  klawI: {
    name: "Klaw (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01113.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  klawIi: {
    name: "Klaw (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01114.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  klawIii: {
    name: "Klaw (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01115.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  undergroundDistribution: {
    name: "Underground Distribution",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01116.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  secretRendezvous: {
    name: "Secret Rendezvous",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01117.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  sonicConverter: {
    name: "Sonic Converter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01118.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  solidSoundBody: {
    name: "Solid-Sound Body",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01119.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  armoredGuard: {
    name: "Armored Guard",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01120.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "KLAW"
    }
  },
  weaponsRunner: {
    name: "Weapons Runner",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01121.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "KLAW"
    }
  },
  klaw039SVengeance: {
    name: "Klaw&#039;s Vengeance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01122.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "KLAW"
    }
  },
  sonicBoom: {
    name: "Sonic Boom",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01123.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "KLAW"
    }
  },
  soundManipulation: {
    name: "Sound Manipulation",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01124.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "KLAW"
    }
  },
  defenseNetwork: {
    name: "Defense Network",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01125.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  illegalArmsFactory: {
    name: "Illegal Arms Factory",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01126.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  theQuotImmortalQuotKlaw: {
    name: "The &quot;Immortal&quot; Klaw",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01127.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "KLAW"
    }
  },
  theMastersOfEvil: {
    name: "The Masters of Evil",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01128.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  radioactiveMan: {
    name: "Radioactive Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01129.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  whirlwind: {
    name: "Whirlwind",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01130.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  tigerShark: {
    name: "Tiger Shark",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01131.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  melter: {
    name: "Melter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01132.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  mastersOfMayhem: {
    name: "Masters of Mayhem",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01133.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "MASTERS_OF_EVIL"
    }
  },
  ultronI: {
    name: "Ultron (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01134.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  ultronIi: {
    name: "Ultron (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01135.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  ultronIii: {
    name: "Ultron (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01136.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  theCrimsonCowl: {
    name: "The Crimson Cowl",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01137.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  assaultOnNorad: {
    name: "Assault on NORAD",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01138.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  countdownToOblivion: {
    name: "Countdown to Oblivion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01139.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  ultronDrones: {
    name: "Ultron Drones",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01140.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  programTransmitter: {
    name: "Program Transmitter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01141.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  upgradedDrones: {
    name: "Upgraded Drones",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01142.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ULTRON"
    }
  },
  advancedUltronDrone: {
    name: "Advanced Ultron Drone",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01143.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ULTRON"
    }
  },
  androidEfficiency: {
    name: "Android Efficiency",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01144c.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  rageOfUltron: {
    name: "Rage of Ultron",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01145.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ULTRON"
    }
  },
  repairSequence: {
    name: "Repair Sequence",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01146.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ULTRON"
    }
  },
  swarmAttack: {
    name: "Swarm Attack",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01147.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ULTRON"
    }
  },
  droneFactory: {
    name: "Drone Factory",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01148.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  invasiveAi: {
    name: "Invasive AI",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01149.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  ultron039SImperative: {
    name: "Ultron&#039;s Imperative",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01150.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ULTRON"
    }
  },
  underAttack: {
    name: "Under Attack",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01151.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "UNDER_ATTACK"
    }
  },
  vibraniumArmor: {
    name: "Vibranium Armor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01152.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "UNDER_ATTACK"
    }
  },
  concussionBlasters: {
    name: "Concussion Blasters",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01153.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "UNDER_ATTACK"
    }
  },
  concussiveBlast: {
    name: "Concussive Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01154.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "UNDER_ATTACK"
    }
  },
  affairsOfState: {
    name: "Affairs of State",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01155.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "BLACK_PANTHER"
    }
  },
  usurpTheThrone: {
    name: "Usurp The Throne",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01156.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  killmonger: {
    name: "Killmonger",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01157.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  heartShapedHerb: {
    name: "Heart-Shaped Herb",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01158.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_PANTHER"
    }
  },
  ritualCombat: {
    name: "Ritual Combat",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01159.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "BLACK_PANTHER"
    }
  },
  legalWork: {
    name: "Legal Work",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01160.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "SHE_HULK"
    }
  },
  personalChallenge: {
    name: "Personal Challenge",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01161.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  titania: {
    name: "Titania",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01162.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  geneticallyEnhanced: {
    name: "Genetically Enhanced",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01163.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SHE_HULK"
    }
  },
  titania039SFury: {
    name: "Titania&#039;s Fury",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01164.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "SHE_HULK"
    }
  },
  evictionNotice: {
    name: "Eviction Notice",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01165.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "SPIDER_MAN"
    }
  },
  highwayRobbery: {
    name: "Highway Robbery",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01166.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SPIDER_MAN"
    }
  },
  vulture: {
    name: "Vulture",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01167.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SPIDER_MAN"
    }
  },
  sweepingSwoop: {
    name: "Sweeping Swoop",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01168.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "SPIDER_MAN"
    }
  },
  theVulture039SPlans: {
    name: "The Vulture&#039;s Plans",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01169.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SPIDER_MAN"
    }
  },
  businessProblems: {
    name: "Business Problems",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01170.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "IRON_MAN"
    }
  },
  imminentOverload: {
    name: "Imminent Overload",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01171.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  whiplash: {
    name: "Whiplash",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01172.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  electricWhipAttack: {
    name: "Electric Whip Attack",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01173.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "IRON_MAN"
    }
  },
  electromagneticBacklash: {
    name: "Electromagnetic Backlash",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01174.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "IRON_MAN"
    }
  },
  familyEmergency: {
    name: "Family Emergency",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01175.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  thePsychMagnitron: {
    name: "The Psych-Magnitron",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01176.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  yonRogg: {
    name: "Yon-Rogg",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01177.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  kreeManipulator: {
    name: "Kree Manipulator",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01178.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  yonRogg039STreason: {
    name: "Yon-Rogg&#039;s Treason",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01179.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "CAPTAIN_MARVEL"
    }
  },
  legionsOfHydra: {
    name: "Legions of Hydra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01180.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "LEGIONS_OF_HYDRA"
    }
  },
  madameHydra: {
    name: "Madame Hydra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01181.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "LEGIONS_OF_HYDRA"
    }
  },
  hydraSoldier: {
    name: "Hydra Soldier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04153.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 3,
      targetName: "HYDRA_PATROL"
    }
  },
  theDoomsdayChair: {
    name: "The Doomsday Chair",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01183.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "THE_DOOMSDAY_CHAIR"
    }
  },
  modok: {
    name: "MODOK",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01184.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THE_DOOMSDAY_CHAIR"
    }
  },
  biomechanicalUpgrades: {
    name: "Biomechanical Upgrades",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01185.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 3,
      targetName: "THE_DOOMSDAY_CHAIR"
    }
  },
  advance: {
    name: "Advance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01186.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "STANDARD"
    }
  },
  assault: {
    name: "Assault",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01187.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "STANDARD"
    }
  },
  caughtOffGuard: {
    name: "Caught Off Guard",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01188.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "STANDARD"
    }
  },
  gangUp: {
    name: "Gang-Up",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01189.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "STANDARD"
    }
  },
  shadowOfThePast: {
    name: "Shadow of the Past",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01190.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "STANDARD"
    }
  },
  exhaustion: {
    name: "Exhaustion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01191.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERT"
    }
  },
  masterplan: {
    name: "Masterplan",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01192.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERT"
    }
  },
  underFire: {
    name: "Under Fire",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01193.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERT"
    }
  },
  breakout: {
    name: "Breakout",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07001.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "WRECKING_CREW"
    }
  },
  wreckerI: {
    name: "Wrecker (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WRECKER"
    }
  },
  wreckerIi: {
    name: "Wrecker (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WRECKER"
    }
  },
  dayOfReckoning: {
    name: "Day of Reckoning",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WRECKER"
    }
  },
  heldHostage: {
    name: "Held Hostage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07050.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  magicCrowbar: {
    name: "Magic Crowbar",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WRECKER"
    }
  },
  wrecker039SCommand: {
    name: "Wrecker&#039;s Command",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WRECKER"
    }
  },
  corruptPrisonGuard: {
    name: "Corrupt Prison Guard",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07052.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  escapedConvict: {
    name: "Escaped Convict",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07053.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  buddySystem: {
    name: "Buddy System",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07054.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  chaosInThePrison: {
    name: "Chaos In the Prison",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07056.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  crowbarToss: {
    name: "Crowbar Toss",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "WRECKER"
    }
  },
  getWrecked: {
    name: "Get Wrecked!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07057.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  i039VeBeenWaitingForThis: {
    name: "I&#039;ve Been Waiting For This!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07041.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "PILEDRIVER"
    }
  },
  mysticalLink: {
    name: "Mystical Link",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "WRECKER"
    }
  },
  you039ReDeadMeat: {
    name: "You&#039;re Dead Meat!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "WRECKER"
    }
  },
  thunderballI: {
    name: "Thunderball (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THUNDERBALL"
    }
  },
  thunderballIi: {
    name: "Thunderball (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THUNDERBALL"
    }
  },
  thunderstruck: {
    name: "Thunderstruck",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THUNDERBALL"
    }
  },
  ballAndChain: {
    name: "Ball and Chain",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04084.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  radioactiveBuildup: {
    name: "Radioactive Buildup",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07022.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THUNDERBALL"
    }
  },
  energyProjectiles: {
    name: "Energy Projectiles",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "THUNDERBALL"
    }
  },
  lightningBlast: {
    name: "Lightning Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "THUNDERBALL"
    }
  },
  tacticalProwess: {
    name: "Tactical Prowess",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "THUNDERBALL"
    }
  },
  piledriverI: {
    name: "Piledriver (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "PILEDRIVER"
    }
  },
  piledriverIi: {
    name: "Piledriver (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "PILEDRIVER"
    }
  },
  pileItOn: {
    name: "Pile It On!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "PILEDRIVER"
    }
  },
  distractingTaunts: {
    name: "Distracting Taunts",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07035.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "PILEDRIVER"
    }
  },
  oversizedHands: {
    name: "Oversized Hands",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07042.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "PILEDRIVER"
    }
  },
  escapePlan: {
    name: "Escape Plan",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07043.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "PILEDRIVER"
    }
  },
  pummel: {
    name: "Pummel",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07044.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "PILEDRIVER"
    }
  },
  uncannyResilience: {
    name: "Uncanny Resilience",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07045.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "PILEDRIVER"
    }
  },
  bulldozerI: {
    name: "Bulldozer (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07046.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  bulldozerIi: {
    name: "Bulldozer (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07047.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  clearTheRoad: {
    name: "Clear the Road",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07048.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  bulldozer039SHelmet: {
    name: "Bulldozer&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07049.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "BULLDOZER"
    }
  },
  rammingSpeed: {
    name: "Ramming Speed",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07051.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "BULLDOZER"
    }
  },
  bullRush: {
    name: "Bull Rush",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07055.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "BULLDOZER"
    }
  },
  headbutt: {
    name: "Headbutt",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07058.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "BULLDOZER"
    }
  },
  leadingTheCharge: {
    name: "Leading the Charge",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC03en_07059.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "BULLDOZER"
    }
  },
  captainAmerica: {
    name: "Captain America",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "CAPTAIN_AMERICA"],
      targetName: "CAPTAIN_AMERICA"
    }
  },
  agent13SharonCarter: {
    name: "Agent 13: Sharon Carter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  fearlessDetermination: {
    name: "Fearless Determination",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  heroicStrike: {
    name: "Heroic Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  shieldBlock: {
    name: "Shield Block",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  shieldToss: {
    name: "Shield Toss",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  steve039SApartment: {
    name: "Steve&#039;s Apartment",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  captainAmerica039SHelmet: {
    name: "Captain America&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  captainAmerica039SShield: {
    name: "Captain America&#039;s Shield",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  superSoldierSerum: {
    name: "Super-Soldier Serum",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAPTAIN_AMERICA", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  falconSamWilson: {
    name: "Falcon: Sam Wilson",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  squirrelGirlDoreenGreen: {
    name: "Squirrel Girl: Doreen Green",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  wonderManSimonWilliams: {
    name: "Wonder Man: Simon Williams",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  avengersAssemble: {
    name: "Avengers Assemble!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  strengthInNumbers: {
    name: "Strength In Numbers",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  quinjet: {
    name: "Quinjet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "SUPPORT"]
    }
  },
  avengersTower: {
    name: "Avengers Tower",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "SUPPORT"]
    }
  },
  honoraryAvenger: {
    name: "Honorary Avenger",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  manOutOfTime: {
    name: "Man Out of Time",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  hitSquad: {
    name: "Hit Squad",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  baronZemo: {
    name: "Baron Zemo",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "CAPTAIN_AMERICA"
    }
  },
  hailHydra: {
    name: "Hail Hydra!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04147.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "HYDRA_ASSAULT"
    }
  },
  enraged: {
    name: "Enraged",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  followed: {
    name: "Followed",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  expertDefense: {
    name: "Expert Defense",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  enhancedAwareness: {
    name: "Enhanced Awareness",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC04en_03034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  msMarvel: {
    name: "Ms. Marvel",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "MS_MARVEL"],
      targetName: "MS_MARVEL"
    }
  },
  redDagger: {
    name: "Red Dagger",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  bigHands: {
    name: "Big Hands",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "MS_MARVEL"
    }
  },
  sneakBy: {
    name: "Sneak By",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "MS_MARVEL"
    }
  },
  wiggleRoom: {
    name: "Wiggle Room",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "MS_MARVEL"
    }
  },
  aamirKhan: {
    name: "Aamir Khan",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  brunoCarrelli: {
    name: "Bruno Carrelli",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  nakiaBahadir: {
    name: "Nakia Bahadir",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  biokineticPolymerSuit: {
    name: "Biokinetic Polymer Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  embiggen: {
    name: "Embiggen!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  shrink: {
    name: "Shrink",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["MS_MARVEL", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  novaSamAlexander: {
    name: "Nova: Sam Alexander",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  preemptiveStrike: {
    name: "Preemptive Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  tackle: {
    name: "Tackle",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  energyBarrier: {
    name: "Energy Barrier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  lockjaw: {
    name: "Lockjaw",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  endurance: {
    name: "Endurance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05023.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  enhancedReflexes: {
    name: "Enhanced Reflexes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  homeByDawn: {
    name: "Home by Dawn",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "MS_MARVEL"
    }
  },
  generationWhy: {
    name: "Generation Why?",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  thomasEdison: {
    name: "Thomas Edison",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  edison039SGiantRobot: {
    name: "Edison&#039;s Giant Robot",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "MS_MARVEL"
    }
  },
  harvest: {
    name: "Harvest",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "MS_MARVEL"
    }
  },
  melee: {
    name: "Melee",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  concussiveBlow: {
    name: "Concussive Blow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  moraleBoost: {
    name: "Morale Boost",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  downTime: {
    name: "Down Time",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC05en_05033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  thor: {
    name: "Thor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "THOR"],
      targetName: "THOR"
    }
  },
  ladySif: {
    name: "Lady Sif",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "THOR"
    }
  },
  defenderOfTheNineRealms: {
    name: "Defender of the Nine Realms",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "THOR"
    }
  },
  forAsgard: {
    name: "For Asgard!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "THOR"
    }
  },
  hammerThrow: {
    name: "Hammer Throw",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "THOR"
    }
  },
  lightningStrike: {
    name: "Lightning Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "THOR"
    }
  },
  asgard: {
    name: "Asgard",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "THOR"
    }
  },
  godOfThunder: {
    name: "God of Thunder",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "THOR"
    }
  },
  mjolnir: {
    name: "Mjolnir",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "THOR"
    }
  },
  thor039SHelmet: {
    name: "Thor&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["THOR", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "THOR"
    }
  },
  hercules: {
    name: "Hercules",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  valkyrie: {
    name: "Valkyrie",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  getOverHere: {
    name: "Get Over Here!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  meanSwing: {
    name: "Mean Swing",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  hallOfHeroes: {
    name: "Hall of Heroes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "SUPPORT"]
    }
  },
  battleFury: {
    name: "Battle Fury",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  jarnbjorn: {
    name: "Jarnbjorn",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  heimdall: {
    name: "Heimdall",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06020.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  invulnerability: {
    name: "Invulnerability",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06021.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  odin039SAnger: {
    name: "Odin&#039;s Anger",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "THOR"
    }
  },
  familyFeud: {
    name: "Family Feud",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "THOR"
    }
  },
  loki: {
    name: "Loki",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "THOR"
    }
  },
  frostGiant: {
    name: "Frost Giant",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "THOR"
    }
  },
  trickster: {
    name: "Trickster",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "THOR"
    }
  },
  underSurveillance: {
    name: "Under Surveillance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  teamwork: {
    name: "Teamwork",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  secondWind: {
    name: "Second Wind",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  enhancedPhysique: {
    name: "Enhanced Physique",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC06en_06034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  blackWidow: {
    name: "Black Widow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "BLACK_WIDOW"],
      targetName: "BLACK_WIDOW"
    }
  },
  winterSoldierBuckyBarnes: {
    name: "Winter Soldier: Bucky Barnes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  covertOps: {
    name: "Covert Ops",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  danceOfDeath: {
    name: "Dance of Death",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  safeHouse29: {
    name: "Safe House #29",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  attacrobatics: {
    name: "Attacrobatics",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  blackWidow039SGauntlet: {
    name: "Black Widow&#039;s Gauntlet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  grapplingHook: {
    name: "Grappling Hook",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  synthSuit: {
    name: "Synth-Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  widow039SBite: {
    name: "Widow&#039;s Bite",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BLACK_WIDOW", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "BLACK_WIDOW"
    }
  },
  agentCoulson: {
    name: "Agent Coulson",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "ALLY"]
    }
  },
  quakeDaisyJohnson: {
    name: "Quake: Daisy Johnson",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "ALLY"]
    }
  },
  stealthStrike: {
    name: "Stealth Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  counterintelligence: {
    name: "Counterintelligence",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  spycraft: {
    name: "Spycraft",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  quincarrier: {
    name: "Quincarrier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08023.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "SUPPORT"]
    }
  },
  targetAcquired: {
    name: "Target Acquired",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  burnNotice: {
    name: "Burn Notice",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "BLACK_WIDOW"
    }
  },
  taskmaster: {
    name: "Taskmaster",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  killerForHire: {
    name: "Killer for Hire",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  deadlyShot: {
    name: "Deadly Shot",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "BLACK_WIDOW"
    }
  },
  counterattack: {
    name: "Counterattack",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  rapidResponse: {
    name: "Rapid Response",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "UPGRADE"]
    }
  },
  defensiveStance: {
    name: "Defensive Stance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  espionage: {
    name: "Espionage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC07en_08033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  doctorStrange: {
    name: "Doctor Strange",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "DOCTOR_STRANGE"],
      targetName: "DOCTOR_STRANGE"
    }
  },
  wong: {
    name: "Wong",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  astralProjection: {
    name: "Astral Projection",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  magicBlast: {
    name: "Magic Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  masterOfTheMysticArts: {
    name: "Master of the Mystic Arts",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  mysticalStudies: {
    name: "Mystical Studies",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  protectiveWard: {
    name: "Protective Ward",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  sanctumSanctorum: {
    name: "Sanctum Sanctorum",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  cloakOfLevitation: {
    name: "Cloak of Levitation",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  magicalEnhancements: {
    name: "Magical Enhancements",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  theEyeOfAgamotto: {
    name: "The Eye of Agamotto",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["DOCTOR_STRANGE", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  brotherVoodooJerichoDrumm: {
    name: "Brother Voodoo: Jericho Drumm",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  clea: {
    name: "Clea",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  ironFistDannyRand: {
    name: "Iron Fist: Danny Rand",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  desperateDefense: {
    name: "Desperate Defense",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  momentumShift: {
    name: "Momentum Shift",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  theNightNurse: {
    name: "The Night Nurse",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "SUPPORT"]
    }
  },
  unflappable: {
    name: "Unflappable",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09020.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  warning: {
    name: "Warning",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09021.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  theSorcererSupreme: {
    name: "The Sorcerer Supreme",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  physicalToll: {
    name: "Physical Toll",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "DOCTOR_STRANGE"
    }
  },
  baronMordo: {
    name: "Baron Mordo",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  openTheDarkDimension: {
    name: "Open the Dark Dimension",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  counterspell: {
    name: "Counterspell",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "DOCTOR_STRANGE"
    }
  },
  thoughtcasting: {
    name: "Thoughtcasting",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "DOCTOR_STRANGE"
    }
  },
  crimsonBandsOfCyttorak: {
    name: "Crimson Bands of Cyttorak",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["INVOCATION", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "INVOCATION"
    }
  },
  imagesOfIkonn: {
    name: "Images of Ikonn",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["INVOCATION", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "INVOCATION"
    }
  },
  sevenRingsOfRaggadorr: {
    name: "Seven Rings of Raggadorr",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["INVOCATION", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "INVOCATION"
    }
  },
  vaporsOfValtorr: {
    name: "Vapors of Valtorr",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09035.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["INVOCATION", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "INVOCATION"
    }
  },
  windsOfWatoomb: {
    name: "Winds of Watoomb",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09036.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["INVOCATION", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "INVOCATION"
    }
  },
  skilledStrike: {
    name: "Skilled Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09037.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  foiled: {
    name: "Foiled!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09038.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  ironManTonyStark: {
    name: "Iron Man: Tony Stark",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC08en_09039.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  hulk: {
    name: "Hulk",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "HULK"],
      targetName: "HULK"
    }
  },
  crushingBlow: {
    name: "Crushing Blow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HULK"
    }
  },
  hulkSmash: {
    name: "Hulk Smash",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HULK"
    }
  },
  subOrbitalLeap: {
    name: "Sub-Orbital Leap",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HULK"
    }
  },
  thunderclap: {
    name: "Thunderclap",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HULK"
    }
  },
  unstoppableForce: {
    name: "Unstoppable Force",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HULK"
    }
  },
  limitlessStrength: {
    name: "Limitless Strength",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "RESOURCE"],
      required: 2,
      targetName: "HULK"
    }
  },
  banner039SLaboratory: {
    name: "Banner&#039;s Laboratory",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "HULK"
    }
  },
  boundlessRage: {
    name: "Boundless Rage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "HULK"
    }
  },
  immovableObject: {
    name: "Immovable Object",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HULK", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "HULK"
    }
  },
  brawn: {
    name: "Brawn",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  sentryRobertReynolds: {
    name: "Sentry: Robert Reynolds",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  sheHulkJenniferWalters: {
    name: "She-Hulk: Jennifer Walters",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  dropKick: {
    name: "Drop Kick",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  toeToToe: {
    name: "Toe to Toe",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  QuotYou039LlPayForThatQuot: {
    name: "&quot;You&#039;ll Pay for That!&quot;",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  martialProwess: {
    name: "Martial Prowess",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  toTheRescue: {
    name: "To the Rescue!",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  innerDemons: {
    name: "Inner Demons",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "HULK"
    }
  },
  abomination: {
    name: "Abomination",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "HULK"
    }
  },
  totalDestruction: {
    name: "Total Destruction",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "HULK"
    }
  },
  clashOfTheTitans: {
    name: "Clash Of The Titans",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 3,
      targetName: "HULK"
    }
  },
  beatCop: {
    name: "Beat Cop",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "SUPPORT"]
    }
  },
  inspiringPresence: {
    name: "Inspiring Presence",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  electrostaticArmor: {
    name: "Electrostatic Armor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  resourceful: {
    name: "Resourceful",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC09en_10032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  hawkeye039SBow: {
    name: "Hawkeye&#039;s Bow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  hawkeye039SQuiver: {
    name: "Hawkeye&#039;s Quiver",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  sonicArrow: {
    name: "Sonic Arrow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  explosiveArrow: {
    name: "Explosive Arrow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  electricArrow: {
    name: "Electric Arrow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  cableArrow: {
    name: "Cable Arrow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  vibraniumArrow: {
    name: "Vibranium Arrow",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  expertMarksman: {
    name: "Expert Marksman",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["HAWKEYE", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  hawkeyeKateBishop: {
    name: "Hawkeye: Kate Bishop",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  blackKnightDaneWhitman: {
    name: "Black Knight: Dane Whitman",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  goliathBillFoster: {
    name: "Goliath: Bill Foster",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  uSAgentJohnWalker: {
    name: "U.S. Agent: John Walker",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  skyCycle: {
    name: "Sky Cycle",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "UPGRADE"]
    }
  },
  teamTraining: {
    name: "Team Training",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "SUPPORT"]
    }
  },
  readyForAction: {
    name: "Ready for Action",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  earth039SMightiestHeroes: {
    name: "Earth&#039;s Mightiest Heroes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04022.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  criminalPast: {
    name: "Criminal Past",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "HAWKEYE"
    }
  },
  crossfire: {
    name: "Crossfire",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  markedForDeath: {
    name: "Marked for Death",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  crossfire039SRifle: {
    name: "Crossfire&#039;s Rifle",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "HAWKEYE"
    }
  },
  sniperShot: {
    name: "Sniper Shot",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "HAWKEYE"
    }
  },
  spiderWoman: {
    name: "Spider-Woman",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04031a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04031b.jpg"
    },
    metadatas: {
      tags: ["HERO", "SPIDER_WOMAN"],
      targetName: "SPIDER_WOMAN"
    }
  },
  captainMarvelCarolDanvers: {
    name: "Captain Marvel: Carol Danvers",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_WOMAN", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "SPIDER_WOMAN"
    }
  },
  finesse: {
    name: "Finesse",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_WOMAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "SPIDER_WOMAN"
    }
  },
  jessicaDrew039SApartment: {
    name: "Jessica Drew&#039;s Apartment",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_WOMAN", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "SPIDER_WOMAN"
    }
  },
  venomBlast: {
    name: "Venom Blast",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04035.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"],
      required: 2,
      targetName: "SPIDER_WOMAN"
    }
  },
  pheromones: {
    name: "Pheromones",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04036.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"],
      required: 2,
      targetName: "SPIDER_WOMAN"
    }
  },
  contaminantImmunity: {
    name: "Contaminant Immunity",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04037.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"],
      required: 2,
      targetName: "SPIDER_WOMAN"
    }
  },
  inconspicuous: {
    name: "Inconspicuous",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04038.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"],
      required: 2,
      targetName: "SPIDER_WOMAN"
    }
  },
  selfPropelledGlide: {
    name: "Self-Propelled Glide",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04039.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["SPIDER_WOMAN", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "SPIDER_WOMAN"
    }
  },
  spiderGirlAnyaCorazon: {
    name: "Spider-Girl: Anya Corazon",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04040.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  pressTheAdvantage: {
    name: "Press the Advantage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04043.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  piercingStrike: {
    name: "Piercing Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04044.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  spiderManPeterParker: {
    name: "Spider-Man: Peter Parker",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04045.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "ALLY"]
    }
  },
  skilledInvestigator: {
    name: "Skilled Investigator",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04047.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  clearTheArea: {
    name: "Clear the Area",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04049.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  uncertainLoyalties: {
    name: "Uncertain Loyalties",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04053.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "SPIDER_WOMAN"
    }
  },
  theViper: {
    name: "The Viper",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04054.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SPIDER_WOMAN"
    }
  },
  theViper039SAmbition: {
    name: "The Viper&#039;s Ambition",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04055.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "RESOURCE", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "SPIDER_WOMAN"
    }
  },
  hydraRegular: {
    name: "Hydra Regular",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04152.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "HYDRA_PATROL"
    }
  },
  crossbonesI: {
    name: "Crossbones (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04058.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  crossbonesIi: {
    name: "Crossbones (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04059.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  crossbonesIii: {
    name: "Crossbones (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04060.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  attackOnMountAthena: {
    name: "Attack on Mount Athena",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04061.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  theInfinityStone: {
    name: "The Infinity Stone",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04062.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  theGetaway: {
    name: "The Getaway",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04063.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  crossbones039MachineGun: {
    name: "Crossbones&#039; Machine Gun",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04064.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  crossbones039Armor: {
    name: "Crossbones&#039; Armor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04065.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  fullAuto: {
    name: "Full Auto",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04067.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "CROSSBONES"
    }
  },
  hardAsNails: {
    name: "Hard as Nails",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04068.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "CROSSBONES"
    }
  },
  raidTheArmory: {
    name: "Raid the Armory",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04069.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "CROSSBONES"
    }
  },
  crossbones039Assault: {
    name: "Crossbones&#039; Assault",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04070.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "CROSSBONES"
    }
  },
  corneredStaff: {
    name: "Cornered Staff",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04071.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "CROSSBONES"
    }
  },
  laserRifle: {
    name: "Laser Rifle",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04072.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERIMENTAL_WEAPONS"
    }
  },
  energyShield: {
    name: "Energy Shield",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04073.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERIMENTAL_WEAPONS"
    }
  },
  powerGauntlets: {
    name: "Power Gauntlets",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04074.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERIMENTAL_WEAPONS"
    }
  },
  exoSuit: {
    name: "Exo-Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04075.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "EXPERIMENTAL_WEAPONS"
    }
  },
  absorbingManI: {
    name: "Absorbing Man (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04076.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  absorbingManIi: {
    name: "Absorbing Man (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04077.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  absorbingManIii: {
    name: "Absorbing Man (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04078.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  noneShallPass: {
    name: "None Shall Pass",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04079.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  denseForest: {
    name: "Dense Forest",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04080.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  snowyHillside: {
    name: "Snowy Hillside",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04081.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  rockyOutcrop: {
    name: "Rocky Outcrop",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04082.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  abandonedFacility: {
    name: "Abandoned Facility",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04083.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  stallTactics: {
    name: "Stall Tactics",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04085.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ABSORBING_MAN"
    }
  },
  swingingStone: {
    name: "Swinging Stone",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04086.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ENVIRONMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ABSORBING_MAN"
    }
  },
  steelKick: {
    name: "Steel Kick",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04087.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ABSORBING_MAN"
    }
  },
  piercingThorns: {
    name: "Piercing Thorns",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04088.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ABSORBING_MAN"
    }
  },
  omniMorphDuplication: {
    name: "Omni-Morph Duplication",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04089.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ABSORBING_MAN"
    }
  },
  icyGrip: {
    name: "Icy Grip",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04090.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ABSORBING_MAN"
    }
  },
  avalanche: {
    name: "Avalanche",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  superAbsorbingPower: {
    name: "Super Absorbing Power",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04092.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ABSORBING_MAN"
    }
  },
  taskmasterI: {
    name: "Taskmaster (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04093.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  taskmasterIi: {
    name: "Taskmaster (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04094.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  taskmasterIii: {
    name: "Taskmaster (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04095.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  huntingDownHeroes: {
    name: "Hunting Down Heroes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04096.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  moonKnightMarcSpector: {
    name: "Moon Knight: Marc Spector",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04097.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["TASKMASTER", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  shangChi: {
    name: "Shang-Chi",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_10098.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["TASKMASTER", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  whiteTigerAngelaDelToro: {
    name: "White Tiger: Angela Del Toro",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04099.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["TASKMASTER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  elektra: {
    name: "Elektra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04100.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["TASKMASTER", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  hydraHunter: {
    name: "Hydra Hunter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04101.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "TASKMASTER"
    }
  },
  taskmaster039SSword: {
    name: "Taskmaster&#039;s Sword",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04102.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  taskmaster039SShield: {
    name: "Taskmaster&#039;s Shield",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04103.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  photographicReflexes: {
    name: "Photographic Reflexes",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04104.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "TASKMASTER"
    }
  },
  mimicry: {
    name: "Mimicry",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04105.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "TASKMASTER"
    }
  },
  huntedByHydra: {
    name: "Hunted by Hydra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04106.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "TASKMASTER"
    }
  },
  capturedByHydra: {
    name: "Captured by Hydra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04107.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 4,
      targetName: "TASKMASTER"
    }
  },
  taskmaster039STrainingCamp: {
    name: "Taskmaster&#039;s Training Camp",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_09108.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "TASKMASTER"
    }
  },
  zolaI: {
    name: "Zola (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04109.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  zolaIi: {
    name: "Zola (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04110.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  zolaIii: {
    name: "Zola (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04111.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  theIslandOfDrZola: {
    name: "The Island of Dr. Zola",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04112.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  theMadDoctor: {
    name: "The Mad Doctor",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04113.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  ultimateBioServant: {
    name: "Ultimate Bio-Servant",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04114.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 4,
      targetName: "ZOLA"
    }
  },
  zola039SMutate: {
    name: "Zola&#039;s Mutate",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04115.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ZOLA"
    }
  },
  berserkMutate: {
    name: "Berserk Mutate",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04116.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ZOLA"
    }
  },
  defensiveProgramming: {
    name: "Defensive Programming",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04117.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ZOLA"
    }
  },
  painInhibitors: {
    name: "Pain Inhibitors",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04118.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ZOLA"
    }
  },
  neurologicalImplants: {
    name: "Neurological Implants",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04119.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ZOLA"
    }
  },
  mindRay: {
    name: "Mind Ray",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04120.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "ZOLA"
    }
  },
  technologicalEnhancements: {
    name: "Technological Enhancements",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04121.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ZOLA"
    }
  },
  hydraPrison: {
    name: "Hydra Prison",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04122.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  testSubjects: {
    name: "Test Subjects",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04123.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "ZOLA"
    }
  },
  zola039SExperiments: {
    name: "Zola&#039;s Experiments",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04124.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "ZOLA"
    }
  },
  redSkullI: {
    name: "Red Skull (I)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04125.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  redSkullIi: {
    name: "Red Skull (II)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04126.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  redSkullIii: {
    name: "Red Skull (III)",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04127.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "VILLAIN", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  theRiseOfTheRedSkull: {
    name: "The Rise of the Red Skull",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04128.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  newWorldHydra: {
    name: "New World Hydra",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04129.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MAINSCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  theSleeper: {
    name: "The Sleeper",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04130.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  hydraExoSoldier: {
    name: "Hydra Exo-Soldier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04131.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 3,
      targetName: "RED_SKULL"
    }
  },
  redSkull039SLuger: {
    name: "Red Skull&#039;s Luger",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04132.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  redSkull039SRightHook: {
    name: "Red Skull&#039;s Right Hook",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04133.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  masterStrategist: {
    name: "Master Strategist",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04134.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  twistedReality: {
    name: "Twisted Reality",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04135.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  bitterRival: {
    name: "Bitter Rival",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04136.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  spreadingLies: {
    name: "Spreading Lies",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04137.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  infinitePower: {
    name: "Infinite Power",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04138.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 2,
      targetName: "RED_SKULL"
    }
  },
  theRedHouse: {
    name: "The Red House",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_10139.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  theSleeperAwakened: {
    name: "The Sleeper Awakened",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04140.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  prisonCamps: {
    name: "Prison Camps",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04141.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  censorThePast: {
    name: "Censor the Past",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04142.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  hydraReinforcements: {
    name: "Hydra Reinforcements",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04143.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  massChaos: {
    name: "Mass Chaos",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04144.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITH_VILLAIN"],
      required: 1,
      targetName: "RED_SKULL"
    }
  },
  hydraFlameSoldier: {
    name: "Hydra Flame-Soldier",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04145.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 3,
      targetName: "HYDRA_ASSAULT"
    }
  },
  hydraJetTrooper: {
    name: "Hydra Jet-Trooper",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04146.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "HYDRA_ASSAULT"
    }
  },
  combatKnife: {
    name: "Combat Knife",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04148.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WEAPON_MASTER"
    }
  },
  hydraSidearm: {
    name: "Hydra Sidearm",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04149.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WEAPON_MASTER"
    }
  },
  weaponMaster: {
    name: "Weapon Master",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_10150.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 2,
      targetName: "WEAPON_MASTER"
    }
  },
  concussionGrenade: {
    name: "Concussion Grenade",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04151.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "WEAPON_MASTER"
    }
  },
  hydraPatrol: {
    name: "Hydra Patrol",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04154.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      required: 1,
      targetName: "HYDRA_PATROL"
    }
  },
  adrenalStims: {
    name: "Adrenal Stims",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04155.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  tacticalScanner: {
    name: "Tactical Scanner",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04156.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  emergencyTeleporter: {
    name: "Emergency Teleporter",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04157.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  laserCannon: {
    name: "Laser Cannon",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04158.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  basicThwartUpgrade: {
    name: "Basic Thwart Upgrade",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04159a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  basicAttackUpgrade: {
    name: "Basic Attack Upgrade",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04160a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  basicDefenseUpgrade: {
    name: "Basic Defense Upgrade",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04161a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  basicRecoveryUpgrade: {
    name: "Basic Recovery Upgrade",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04162a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "UPGRADE"]
    }
  },
  zola039SAlgorithm: {
    name: "Zola&#039;s Algorithm",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04163.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "OBLIGATION"],
      nemesis: true,
      targetName: "EXPERT_CAMPAIGN"
    }
  },
  medicalEmergency: {
    name: "Medical Emergency",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04164.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "OBLIGATION"],
      nemesis: true,
      targetName: "EXPERT_CAMPAIGN"
    }
  },
  martialLaw: {
    name: "Martial Law",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04165.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "OBLIGATION"],
      nemesis: true,
      targetName: "EXPERT_CAMPAIGN"
    }
  },
  antiHeroPropaganda: {
    name: "Anti-Hero Propaganda",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC10en_04166.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["CAMPAIGN", "OBLIGATION"],
      nemesis: true,
      targetName: "EXPERT_CAMPAIGN"
    }
  },
  antMan: {
    name: "Ant-Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12001c.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "ANT_MAN"],
      targetName: "ANT_MAN"
    }
  },
  waspNadiaVanDyne: {
    name: "Wasp: Nadia Van Dyne",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  giantStomp: {
    name: "Giant Stomp",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "ANT_MAN"
    }
  },
  hiveMind: {
    name: "Hive Mind",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  resize: {
    name: "Resize",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "ANT_MAN"
    }
  },
  pymParticles: {
    name: "Pym Particles",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "RESOURCE"],
      required: 2,
      targetName: "WASP"
    }
  },
  armyOfAnts: {
    name: "Army of Ants",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "SUPPORT"],
      required: 3,
      targetName: "ANT_MAN"
    }
  },
  antMan039SHelmet: {
    name: "Ant-Man&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  giantStrength: {
    name: "Giant Strength",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "UPGRADE"],
      required: 2,
      targetName: "ANT_MAN"
    }
  },
  wristGauntlets: {
    name: "Wrist Gauntlets",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ANT_MAN", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  antManHankPym: {
    name: "Ant-Man: Hank Pym",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  giantMan: {
    name: "Giant-Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  ronin: {
    name: "Ronin",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  stingerCassieLang: {
    name: "Stinger: Cassie Lang",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "ALLY"]
    }
  },
  callForAid: {
    name: "Call for Aid",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  moxie: {
    name: "Moxie",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  powerGloves: {
    name: "Power Gloves",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "UPGRADE"]
    }
  },
  reinforcedSuit: {
    name: "Reinforced Suit",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "UPGRADE"]
    }
  },
  teamBuildingExercise: {
    name: "Team-Building Exercise",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "SUPPORT"]
    }
  },
  careForCassie: {
    name: "Care for Cassie",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "ANT_MAN"
    }
  },
  techTheft: {
    name: "Tech Theft",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  yellowjacket: {
    name: "Yellowjacket",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  sizeIncrease: {
    name: "Size Increase",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "ANT_MAN"
    }
  },
  yellowjacket039SPlan: {
    name: "Yellowjacket&#039;s Plan",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "ANT_MAN"
    }
  },
  momentOfTriumph: {
    name: "Moment of Triumph",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  layDownTheLaw: {
    name: "Lay Down the Law",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  musterCourage: {
    name: "Muster Courage",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  assessTheSituation: {
    name: "Assess the Situation",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC12en_12033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  wasp: {
    name: "Wasp",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13001c.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "WASP"],
      targetName: "WASP"
    }
  },
  antManScottLang: {
    name: "Ant-Man: Scott Lang",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "WASP"
    }
  },
  giantHelp: {
    name: "Giant Help",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "WASP"
    }
  },
  pinpointStrike: {
    name: "Pinpoint Strike",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "EVENT"],
      required: 3,
      targetName: "WASP"
    }
  },
  rapidGrowth: {
    name: "Rapid Growth",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "WASP"
    }
  },
  waspSting: {
    name: "Wasp Sting",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "WASP"
    }
  },
  redRoomTraining: {
    name: "Red Room Training",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "WASP"
    }
  },
  bioSyntheticWings: {
    name: "Bio-Synthetic Wings",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "WASP"
    }
  },
  wasp039SHelmet: {
    name: "Wasp&#039;s Helmet",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["WASP", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "WASP"
    }
  },
  thorJaneFoster: {
    name: "Thor: Jane Foster",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  waspJanetVanDyne: {
    name: "Wasp: Janet Van Dyne",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "ALLY"]
    }
  },
  intoTheFray: {
    name: "Into the Fray",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  surpriseAttack: {
    name: "Surprise Attack",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "EVENT"]
    }
  },
  bootCamp: {
    name: "Boot Camp",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13016.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "SUPPORT"]
    }
  },
  lieInWait: {
    name: "Lie in Wait",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  ironheart: {
    name: "Ironheart",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  spiderManMilesMorales: {
    name: "Spider-Man: Miles Morales",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13019.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "ALLY"]
    }
  },
  swarmTactics: {
    name: "Swarm Tactics",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13020.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  thePowerInAllOfUs: {
    name: "The Power in All of Us",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "RESOURCE"]
    }
  },
  redDreams: {
    name: "Red Dreams",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13026.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "WASP"
    }
  },
  mother039SOrders: {
    name: "Mother&#039;s Orders",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "WASP"
    }
  },
  beetle: {
    name: "Beetle",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "MINION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "WASP"
    }
  },
  beetleArmorMkIv: {
    name: "Beetle Armor MK IV",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "WASP"
    }
  },
  beetleMania: {
    name: "Beetle Mania",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "WASP"
    }
  },
  runningInterference: {
    name: "Running Interference",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "EVENT"]
    }
  },
  allForOne: {
    name: "All for One",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  perseverance: {
    name: "Perseverance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13033.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  athleticConditioning: {
    name: "Athletic Conditioning",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC13en_13034.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  quicksilver: {
    name: "Quicksilver",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14001a.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14001b.jpg"
    },
    metadatas: {
      tags: ["HERO", "QUICKSILVER"],
      targetName: "QUICKSILVER"
    }
  },
  scarletWitchWandaMaximoff: {
    name: "Scarlet Witch: Wanda Maximoff",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14002.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "ALLY"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  alwaysBeRunning: {
    name: "Always Be Running",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14003.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "EVENT"],
      required: 4,
      targetName: "QUICKSILVER"
    }
  },
  doubleTime: {
    name: "Double Time",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14004.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "QUICKSILVER"
    }
  },
  maximumVelocity: {
    name: "Maximum Velocity",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14005.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "EVENT"],
      required: 2,
      targetName: "QUICKSILVER"
    }
  },
  speedCyclone: {
    name: "Speed Cyclone",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14006.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "EVENT"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  servalIndustries: {
    name: "Serval Industries",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14007.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "SUPPORT"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  acceleratedReflex: {
    name: "Accelerated Reflex",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14008.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  frictionResistance: {
    name: "Friction Resistance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14009.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  hyperPerception: {
    name: "Hyper Perception",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14010.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  reinforcedSinew: {
    name: "Reinforced Sinew",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14011.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["QUICKSILVER", "HERO_CARD", "UPGRADE"],
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  multipleMan: {
    name: "Multiple Man",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14012.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  warlock: {
    name: "Warlock",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14013.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "ALLY"]
    }
  },
  neverBackDown: {
    name: "Never Back Down",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14014.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  sideStep: {
    name: "Side Step",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14015.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "EVENT"]
    }
  },
  nervesOfSteel: {
    name: "Nerves of Steel",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14017.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["PROTECTION", "UPGRADE"]
    }
  },
  orderAndChaos: {
    name: "Order and Chaos",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14018.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  },
  adrenalineRush: {
    name: "Adrenaline Rush",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14022.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  civicDuty: {
    name: "Civic Duty",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14023.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "UPGRADE"]
    }
  },
  needForSpeed: {
    name: "Need for Speed",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14024.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "OBLIGATION", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      targetName: "QUICKSILVER"
    }
  },
  extortionOfSeismicProportion: {
    name: "Extortion of Seismic Proportion",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14025.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "SIDESCHEME", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  vibrationResistance: {
    name: "Vibration Resistance",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14027.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "ATTACHMENT", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 1,
      targetName: "QUICKSILVER"
    }
  },
  earthquake: {
    name: "Earthquake",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14028.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["ENCOUNTER", "TREACHERY", "ENCOUNTER_CATEGORY_WITHOUT_VILLAIN"],
      nemesis: true,
      required: 2,
      targetName: "QUICKSILVER"
    }
  },
  bruteForce: {
    name: "Brute Force",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14029.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["AGGRESSION", "UPGRADE"]
    }
  },
  senseOfJustice: {
    name: "Sense of Justice",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14030.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["JUSTICE", "UPGRADE"]
    }
  },
  unitedWeStand: {
    name: "United We Stand",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14031.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["LEADERSHIP", "EVENT"]
    }
  },
  beat039EmUp: {
    name: "Beat &#039;Em Up",
    images: {
      front:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC14en_14032.jpg",
      back:
        "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/mc-back0.jpg"
    },
    metadatas: {
      tags: ["BASIC", "EVENT"]
    }
  }
};
